module.exports = __webpack_public_path__ + "static/Master_AleCovid19_Draft2-61d92764cd38a614f828c304739529ea.mp4";